import tw, { styled } from 'twin.macro';
import { P } from '@student-coin/coinpaper-components';

export const Container = styled.div``;

export const Header = styled(P).attrs({ variant: 'medium' })`
  ${tw`font-semibold`};
`;
